import React, { useContext } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { DropdownSubmenu } from "react-bootstrap-submenu";
import { NavLink, Link } from "react-router-dom";
import { CartContext } from "../context/CartContext"; // Importamos el contexto

function NavMenu() {
  // Extraemos las categorías de la DB del contexto global
  const { dbCategories } = useContext(CartContext);

  // Filtramos las categorías para el submenú "+ modelos"
  // Excluimos las que ya se muestran fijas en el submenú "Promo"
  const modelosAdicionales = dbCategories.filter(
    (item) =>
      item.nombre !== "redondos" &&
      item.nombre !== "cuadrados" &&
      item.nombre !== "lectura" &&
      item.nombre !== "eye cat" &&
      item.nombre !== "infantiles",
  );

  return (
    <div className="navMenu">
      <div className="navbarContainer">
        <Dropdown className="d-inline">
          <Dropdown.Toggle as="div" id="dropdown" style={{ cursor: "pointer" }}>
            <Link to="#">
              <div className="botonCatalogo">Catalogo</div>
            </Link>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {/* SUBMENÚ FIJO (PROMO) */}
            <DropdownSubmenu title="Promo >">
              <Dropdown.Item as={NavLink} to="/categoria/redondos/">
                Redondos
              </Dropdown.Item>
              <Dropdown.Item as={NavLink} to="/categoria/cuadrados/">
                Cuadrados
              </Dropdown.Item>
              <Dropdown.Item as={NavLink} to="/categoria/eye cat/">
                Eye cat
              </Dropdown.Item>
              <Dropdown.Item as={NavLink} to="/categoria/infantiles/">
                Infantiles
              </Dropdown.Item>
              <Dropdown.Item as={NavLink} to="/categoria/lectura/">
                Lectura
              </Dropdown.Item>
            </DropdownSubmenu>

            {/* SUBMENÚ DINÁMICO (RESTO DE CATEGORÍAS) */}
            <div id="otrosModelos">
              <DropdownSubmenu title="+ modelos >">
                {modelosAdicionales.length > 0 ? (
                  modelosAdicionales.map((cat) => (
                    <Dropdown.Item as="div" key={cat.id}>
                      <NavLink
                        to={`/categoria/${cat.nombre}/`}
                        className="categoria"
                      >
                        {cat.nombre}
                      </NavLink>
                    </Dropdown.Item>
                  ))
                ) : (
                  <Dropdown.Item disabled>No hay más modelos</Dropdown.Item>
                )}
              </DropdownSubmenu>
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}

export default NavMenu;
